module.exports = __webpack_public_path__ + "static/media/makesThick.7e17a153.mp3";